import { B2BCart } from "@/types/global"
import { missingForCheckout } from "@/lib/util/checkout-readiness"

// First incomplete step per the shared readiness check (24 Sep 2026): a cart with a street but no suburb/state/
// postcode, or no billing, is sent back to that step instead of skipping ahead.
export function getCheckoutStep(cart: B2BCart) {
  const missing = missingForCheckout(cart as any)
  if (missing.length) return missing[0].step
  if (!cart.payment_collection?.payment_sessions?.find((s: any) => s.status === "pending")) return "payment"
  return null
}
